import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { useUserCanManageSeatSaver } from 'src/hooks/useUserHasListingPermissions';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

export const LaunchBulkUpdateDeliveryType = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const hasManageSeatSaverPermission = useUserCanManageSeatSaver();

  const hasSeatSaverFeature = useUserHasFeature(Feature.SeatSaver);

  if (!hasManageSeatSaverPermission || !hasSeatSaverFeature) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="update-delivery-type-event-inventory"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <Content id={ContentId.UpdateDeliveryTypeForPlaceholders} />
        </Stack>
      </PosDropdownItem>
    </>
  );
};
